// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getChatsList, getChat, sendMessage } from "@src/api/internalUsersAPI";

// ** Axios Imports
import axios from "axios";

export const getUserProfile = createAsyncThunk("appChat/getTasks", async () => {
  const response = await axios.get("/apps/chat/users/profile-user");
  return response.data;
});

export const getChatContacts = createAsyncThunk(
  "appChat/getChatContacts",
  async () => {
    const response = await getChatsList();

    return response;
  }
);

export const selectChat = createAsyncThunk(
  "appChat/selectChat",
  async (item, {}) => {
    const response = await getChat(item.userType, item.userId);
    const formattedResponse = {
      contact: {
        id: item.userId,
        name: item.user,
        type: item.userType,
      },
      chat: response.data,
      item,
    };
    return formattedResponse;
  }
);

export const sendMsg = createAsyncThunk(
  "appChat/sendMsg",
  // eslint-disable-next-line no-unused-vars
  async (obj, { dispatch, getState }) => {
    const state = getState();
    const data = {
      saveToChat: true,
      sendWhatsApp: true,
      sendPush: false,
      sendText: false,
      sendEmail: true,
      recipientType: obj.contact.type,
      bookingId: null,
      candidateId: obj.contact.type === "Candidate" ? obj.contact.id : null,
      clientUserId: obj.contact.type === "ClientUser" ? obj.contact.id : null,
      mobile: obj.contact.type === "Unknown" ? obj.contact.id : null,
      template_name: "keep_in_touch",
      template_values: [
        state.internalUsers.LoggedInUser.firstname,
        obj.message,
      ],
      internalUserId: state.internalUsers.LoggedInUser.id,
    };

    await sendMessage(data);
    const datasend = obj.item;
    await dispatch(selectChat(datasend));
    await dispatch(getChatContacts());

    // return response.data;
    return true;
  }
);

export const appChatSlice = createSlice({
  name: "appChat",
  initialState: {
    chats: [],
    contacts: [],
    userProfile: {},
    selectedUser: {},
    unread: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.userProfile = action.payload;
      })
      .addCase(getChatContacts.fulfilled, (state, action) => {
        const sortedChats = action.payload.data.sort((a, b) => {
          const dateA = new Date(a.latestChatDate);
          const dateB = new Date(b.latestChatDate);
          return dateB - dateA; // For descending order (latest date first)
        });

        state.chats = sortedChats;
        state.contacts = action.payload.contacts;
        state.unread = action.payload.unread;
      })
      .addCase(selectChat.fulfilled, (state, action) => {
        state.selectedUser = action.payload;
      });
  },
});

export default appChatSlice.reducer;
